module.exports = __webpack_public_path__ + "static/media/logo logi.df54c334.png";